import { Box, FormControlLabel, Grid, Switch, Typography } from "@mui/material";
import {
  ISituacaoCadastral,
  SituacaoCadastralKeys,
} from "../../../../../../../application/models";
import { HeaderFiltro } from "../header-filtro";
import { useAppSelector } from "../../../../../../hooks/store-hooks";
import { useProjetosService } from "../../../../../../../use-cases/geo-veles";
import { useEffect } from "react";

export const scoreDescriptionToLabel = (
  situacaoCadastralDescriptionKey: ISituacaoCadastral
) => {
  switch (situacaoCadastralDescriptionKey) {
    case "REGULAR":
      return "REGULAR";
    case "PENDENTE DE REGULARIZACAO":
      return "PENDENTE DE REGULARIZAÇÃO";
    case "SUSPENSA":
      return "SUSPENSA";
    case "CANCELADA":
      return "CANCELADA";
    case "NULA":
      return "NULA";
    case "INFORMACAO NAO EXISTENTE NA RECEITA":
      return "INFORMAÇÃO NÃO EXISTENTE NA RECEITA";
    default:
      return "Não definido";
  }
};

export const FiltroSituacaoCadastral = () => {
  // State
  const { filtrosSelecionados } = useAppSelector((state) => state.projetos);
  // Hook
  const { addSituacaoCadastralFilter, 
    removeSituacaoCadastralFilter 
  } = useProjetosService();

  useEffect(() => {
    // If no situacaoCadastral is selected, set default filters
    if (!filtrosSelecionados?.situacaoCadastral?.length) {
      addSituacaoCadastralFilter("REGULAR");
      addSituacaoCadastralFilter("PENDENTE DE REGULARIZACAO");
    }
  }, [])

  return (
    <>
      <HeaderFiltro
        titulo="Situação Cadastral"
        descricao={
          <>
            <Typography>
              A opção abaixo possui o intuito de filtrar pessoas a partir da
              situação de cadastro do seu CPF.
            </Typography>
            <Typography>
              A <strong>situação cadastral</strong> tem abaixo as possíveis
              situações que o CPF pode estar
            </Typography>
            <Typography style={{ marginBottom: "10px" }}>
              Você pode selecionar mais de um tipo de situação cadastral
              diferente.
            </Typography>
            <Typography>
              Caso nenhuma opção seja selecionada, serão levados em consideração
              os tipos "Regular" e "Pendente de regularização", como mostram os
              botões já marcados.
            </Typography>
          </>
        }
      />

      <Box p={3} style={{ marginTop: "10px" }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography
              variant="h6"
              color="primary"
              fontWeight="bold"
              textTransform={"uppercase"}
            >
              Situação Cadastral:
            </Typography>
          </Grid>
          {SituacaoCadastralKeys.map((situacao) => (
            <Grid item xs={4} key={situacao}>
              <FormControlLabel
                label={scoreDescriptionToLabel(situacao).toUpperCase()}
                control={
                  <Switch
                    checked={
                      filtrosSelecionados?.situacaoCadastral?.length === 0
                        ? false
                        : filtrosSelecionados?.situacaoCadastral?.includes(
                            situacao
                          ) ?? false
                    }
                    inputProps={{ "aria-label": "controlled" }}
                    onChange={(e) => {
                      if (e.target.checked) {
                        addSituacaoCadastralFilter(situacao);
                      } else {
                        removeSituacaoCadastralFilter(situacao);
                      }
                    }}
                  />
                }
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  )
}